/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 酸素流量条件
 */
export type VitalO2FlowConditionEnum =
  (typeof VitalO2FlowConditionEnum)[keyof typeof VitalO2FlowConditionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VitalO2FlowConditionEnum = {
  NONE: 'NONE',
  MASK: 'MASK',
  RM: 'RM',
  OTHER: 'OTHER',
} as const;
